import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import ButtonCTA from '../CTAs/ButtonCTA';
import Header from '../Type/Header';
import Grid from '../Grid/Grid';
import Cell from '../Grid/Cell';
import BackgroundLayer from './BackgroundLayer';

import './FlushPanel.module.css';

class FlushPanel extends PureComponent {
  render() {
    const {
      image,
      headline,
      classes,
      styles,
      children,
      imageAlign,
      buttonText,
      buttonUrl,
      copyAreaSize
    } = this.props;
    const imageAreaSize = (24 - copyAreaSize).toString();
    const bgImageSize = (imageAreaSize / 24) * 100;
    let imageOrder = 1;
    if (imageAlign === 'right') {
      imageOrder = 2;
    }
    let stylesExtra;
    return (
      <BackgroundLayer
        imageUrl={image}
        imageSize={bgImageSize}
        imageAlign={imageAlign}
        backgroundColor="#eee"
      >
        <div
          styleName="panel"
          className={classes}
          style={(styles, stylesExtra)}
        >
          <Grid
            direction="x"
            classes="grid"
            styles={{ zIndex: 2, position: 'relative' }}
          >
            <Cell mediumSize={imageAreaSize} styles={{ order: imageOrder }}>
              <div styleName="largeImage" />
            </Cell>
            <Cell
              mediumSize={copyAreaSize}
              styles={{ order: 1 }}
              secondaryAlignment="align-self-middle"
            >
              <div styleName="content">
                <Header level={3} displayAs={2}>
                  {headline}
                </Header>
                {children}{' '}
                {buttonText && buttonUrl && (
                  <ButtonCTA url={buttonUrl}>{buttonText}</ButtonCTA>
                )}
              </div>
            </Cell>
          </Grid>
        </div>
      </BackgroundLayer>
    );
  }
}

FlushPanel.propTypes = {
  /** The large image URL */
  image: PropTypes.string,
  /** Headline title */
  headline: PropTypes.string.isRequired,
  imageAlign: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  copyAreaSize: PropTypes.string,
  classes: PropTypes.any,
  styles: PropTypes.object,
  children: PropTypes.node
};

export default DisplayComponent(FlushPanel);
